<template>
  <div class="mainwrap">
    <el-container>
      <i class="switchbar" :class="{ active: !flag }" @click="check"></i>
      <div class="forsidebar" :class="{ active: flag }">
        <Aside></Aside>
      </div>
      <el-container>
        <div class="main">
          <Heading></Heading>
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'layout',
  data() {
    return {
      flag: true,
    }
  },
  methods: {
    check() {
      this.flag = !this.flag
    },
  },
}
</script>
<style lang="scss" scoped>
.forsidebar {
  background: $c;
  background-image: linear-gradient(180deg, rgba($c, 0.45) 45%, rgba($c, 0.8) 80%, rgba($c, 1) 100%), linear-gradient($c, $c);

  &.active {
    width: 258px;
    overflow: inherit;
  }

  width: 0;
  overflow: hidden;
}

.switchbar {
  width: 0;
  height: 0;
  border-right: 10px solid #fff;
  font-size: 0;
  border-left: 10px solid transparent;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  position: fixed;
  z-index: 9;
  cursor: pointer;
  left: 230px;
  top: 90vh;

  &.active {
    left: 10px;
    border-right: 10px solid $c;
    transform: rotate(180deg);

    &::after {
      background: $c;
    }
  }

  &::after {
    position: absolute;
    width: 4px;
    height: 20px;
    background: #fff;
    content: '';
    left: 12px;
    top: -10px;
  }
}
</style>
